import { useParams } from "react-router-dom";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "MorningBox tratta i dati personali di partner e ospiti nel rispetto del Regolamento UE 2016/679 (GDPR).",
      "Raccogliamo i dati necessari alla registrazione dei partner (dati struttura/attività, referente, contatti) e alla gestione degli ordini (nome ospite, camera, telefono).",
      "I dati sono utilizzati esclusivamente per l'erogazione del servizio e non vengono ceduti a terzi non autorizzati.",
      "In qualsiasi momento puoi richiedere accesso, rettifica o cancellazione dei tuoi dati scrivendo a info@morningbox.it.",
    ],
  },
  cookie: {
    title: "Cookie Policy",
    body: [
      "Questo sito utilizza cookie tecnici necessari al funzionamento e cookie di analisi anonimi per migliorare l'esperienza.",
      "I cookie tecnici non richiedono consenso. I cookie di analisi vengono attivati solo previo consenso tramite il banner.",
      "Puoi modificare le preferenze in qualsiasi momento cancellando i cookie dal tuo browser.",
    ],
  },
  termini: {
    title: "Termini e Condizioni",
    body: [
      "L'utilizzo della piattaforma MorningBox implica l'accettazione dei presenti termini.",
      "MorningBox agisce come intermediario tecnologico tra strutture ricettive, locali e ospiti.",
      "I prezzi, i pacchetti e le modalità di consegna sono definiti dai partner. MorningBox applica una commissione configurabile su ogni ordine.",
      "Durante la fase di test i pagamenti possono avvenire in struttura o tramite carta; gli importi vengono contabilizzati internamente.",
    ],
  },
  "condizioni-bnb": {
    title: "Condizioni per B&B",
    body: [
      "Il B&B è responsabile della correttezza dei dati inseriti e dei prezzi applicati ai propri ospiti.",
      "Il B&B può collegarsi esclusivamente ai locali approvati e convenzionati nella propria città.",
      "Il margine del B&B e la commissione MorningBox vengono calcolati automaticamente su ogni ordine.",
    ],
  },
  "condizioni-bar": {
    title: "Condizioni per bar e pasticcerie",
    body: [
      "Il locale è responsabile della preparazione, della qualità e della sicurezza alimentare dei prodotti.",
      "Il locale definisce i propri prezzi, orari, giorni di chiusura e modalità di ritiro/consegna.",
      "Il locale si impegna ad aggiornare tempestivamente disponibilità e stato degli ordini.",
    ],
  },
};

export default function Legal() {
  const { type } = useParams();
  const data = CONTENT[type] || CONTENT.privacy;
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16">
      <span className="text-xs uppercase tracking-[0.2em] font-semibold text-orange">Documento legale</span>
      <h1 className="mt-3 text-3xl lg:text-4xl font-extrabold text-navy tracking-tight">{data.title}</h1>
      <div className="mt-4 inline-block bg-cream text-navy/60 text-sm rounded-full px-4 py-1.5">Documento provvisorio · fase di pre-lancio</div>
      <div className="mt-8 space-y-4">
        {data.body.map((p, i) => (<p key={i} className="text-navy/70 leading-relaxed">{p}</p>))}
      </div>
      <p className="mt-10 text-sm text-navy/40">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}. Per informazioni: info@morningbox.it</p>
    </div>
  );
}
